export const sizesMainImage = '(min-width: 93.75rem) 43.875rem, (min-width: 75rem) calc(46.8212vw - 0.875rem), (min-width: 64rem) calc(45.3125vw - 0.875rem), (min-width: 48rem) calc(80vw - 1.40rem), 100vw';
